import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2787d9fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "text-lg font-bold primary-txt" }
const _hoisted_3 = { class: "text-gray-500 text-sm mb-3 primary-txt" }
const _hoisted_4 = { class: "product-list overflow-y-auto max-h-72" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "text-base font-semibold primary-txt" }
const _hoisted_8 = { class: "flex justify-end gap-2" }

import { ref, watch } from "vue";

export interface SaleDetailItem {
  id?: number;
  product: { id: number; name: string; full_price?: number; photo?: string };
  quantity: number;
  discount_quantity?: number;
  total?: number;
}


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "LbrxProductSelectionModal",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    open: { type: Boolean },
    saleDetails: {},
    posConfig: {}
  },
  emits: ["update:open", "select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = ref(props.open);
const selectedItem = ref<SaleDetailItem | null>(null);

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue;
    if (newValue) selectedItem.value = null;
  }
);
watch(isOpen, (newValue) => {
  emit("update:open", newValue);
});

function close() {
  isOpen.value = false;
}

function confirm() {
  if (selectedItem.value) {
    emit("select", selectedItem.value);
    isOpen.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    width: "600px",
    centered: "",
    open: isOpen.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event))
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("Pos.ProductSelection")), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("Pos.SelectOneProduct")), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_a_button, {
          size: "large",
          onClick: close,
          class: "primary-txt"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Pos.Cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "primary-txt primary-btn",
          size: "large",
          type: "primary",
          disabled: !selectedItem.value,
          style: _normalizeStyle(
            _ctx.posConfig?.store?.primaryColor
              ? {
                  backgroundColor: _ctx.posConfig.store.primaryColor,
                  borderColor: _ctx.posConfig.store.primaryColor,
                }
              : {}
          ),
          onClick: confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("Pos.Confirm")), 1)
          ]),
          _: 1
        }, 8, ["disabled", "style"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saleDetails, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id ?? index,
            class: _normalizeClass([
          'product-row flex items-center justify-between rounded-lg mb-2 px-3 py-2 cursor-pointer transition border-2',
          selectedItem.value === item
            ? 'border-primary bg-primary/10'
            : 'border-transparent bg-gray-50 hover:bg-gray-100',
        ]),
            style: _normalizeStyle(
          selectedItem.value === item && _ctx.posConfig?.store?.primaryColor
            ? {
                borderColor: _ctx.posConfig.store.primaryColor,
                backgroundColor: _ctx.posConfig.store.primaryColor + '20',
              }
            : {}
        ),
            onClick: ($event: any) => (selectedItem.value = item)
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.product?.name ?? "-"), 1)
            ])
          ], 14, _hoisted_5))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})